// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3F-by","detailsBorder":"styles_detailsBorder__3_1qZ"};